var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImportContactGridIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_Circle_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "correct_24px",
    d: "M24,12A12,12,0,1,1,12,0,11.993,11.993,0,0,1,24,12Zm-1.875,0A10.125,10.125,0,1,0,12,22.125,10.119,10.119,0,0,0,22.125,12Zm0,0",
    transform: "translate(0 0)",
    fill: "#0d0d0d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(-1158.831 -455.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M7193.7,7205.6a17.632,17.632,0,0,1,0-2.3.4.4,0,0,1,.1-.3l7-7,2.4,2.4-2.2,2.3-4.7,4.6a.7.7,0,0,1-.6.3Z",
    transform: "translate(-6028.7 -6732.7)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M7204,7197.6l-2.4-2.4a6.726,6.726,0,0,1,1.2-1.2.6.6,0,0,1,.9.1l1.5,1.5a.5.5,0,0,1,0,.8,13.72,13.72,0,0,1-1.2,1.2Z",
    transform: "translate(-6028.7 -6732.7)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImportContactGridIcon);
export default __webpack_public_path__ + "static/media/edit-import-contact-grid-icon.e03d3cc78a8a9a4fd1799afa275917b2.svg";
export { ForwardRef as ReactComponent };